export default ({
  background,
  navForeground,
  navStyle,
  toggled
}, {
  colors,
  mediaQuery,
  rhythm,
  shadows,
  transitions,
  treatments
}) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexPack: 'justify',

    '& > *': {
      display: 'block'
    }
  },

  nav: {
    color: colors[navForeground],
    ...treatments[navStyle],

    [mediaQuery('lg', 'max-width')]: {
      position: 'absolute',
      top: '100%',
      left: 0,
      right: 0,
      padding: `${rhythm(1)} ${rhythm(1.5)}`,
      backgroundColor: colors[background],
      borderTop: `1px solid ${colors.shade}`,
      boxShadow: shadows.bottom,
      transition: transitions.easeOut,
      visibility: toggled ? 'visible' : 'hidden',
      opacity: toggled ? 1 : 0
    },

    [mediaQuery('lg')]: {
      display: 'flex',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      margin: rhythm(-0.5),
      '& > *': {
        margin: rhythm(0.5)
      }
    }
  },

  toggle: {
    color: colors[navForeground],
    [mediaQuery('lg')]: {
      display: 'none'
    }
  }
})
